module.exports = __webpack_public_path__ + "cdea34aecb9cb3dc2d1bc003f0af3efc.svg";